import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { statusColours } from '../../constants/ColourConstants';
// constants
import ROLES from '../../constants/Roles';
// components
import { Card, CardHeader, CardText } from 'material-ui/Card';

import VenueIcon from 'material-ui/svg-icons/communication/location-on';
import LocationSegment from '../Location/LocationSegment';
import AssetSegment from '../Asset/AssetSegment';

import Chip from '../Common/Chip';
import DetailView from '../Common/DetailView';
import SimpleMap from '../Map/SimpleMap';
// icons
import ContactIcon from 'material-ui/svg-icons/social/person';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import ScheduleIcon from 'material-ui/svg-icons/communication/clear-all';
// business logic
import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';
import VenueAssetStore from '../../stores/VenueAssetStore';
import VenueContactStore from '../../stores/VenueContactStore';
import VenueLocationStore from '../../stores/VenueLocationStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';

const style = {

    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


const Venue = React.createClass({

    getInitialState: function () {

        return {

            details: {
                id: '',
                name: '',
                description: '',
                locations: '',
                capacity: '',
            },
            locations: [],
            contacts: [],
            actions: [],
            assets: [],
            menuItems: [
                {
                    link: `/dashboard/venue/${this.props.id}/schedule`,
                    icon: <ScheduleIcon />,
                    label: 'Schedule',
                },
                {
                    type: 'divider'
                },
                {
                    link: '/dashboard/venue/' + this.props.id + '/settings',
                    icon: <SettingsIcon />,
                    label: 'Settings',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    link: `/dashboard/venue/${this.props.id}/edit`,
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
            ],
            links: {
                back: '/dashboard/venues',
                edit: '',
            }
        }
    },


    componentDidMount: function() {
        VenueStore.addChangeListener(this.onVenueChange);
        VenueActions.getById(this.props.id);

        VenueLocationStore.addChangeListener(this.onLocationsChange);
        VenueActions.getLocations(this.props.id);

        VenueContactStore.addChangeListener(this.onVenueContactChange);
        VenueActions.getContacts(this.props.id);

        this.assetListener = VenueAssetStore.addListener(this.onAssetChange);
        VenueActions.listAssets(this.props.id);

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
    },

    componentWillUnmount: function() {
        VenueContactStore.removeChangeListener(this.onVenueContactChange);
        VenueLocationStore.removeChangeListener(this.onLocationsChange);
        VenueStore.removeChangeListener(this.onVenueChange);
        this.assetListener.remove();
    },

    render: function () {

        let displayMap;

        const segmentLocations = <LocationSegment locations={this.state.locations} />;
        const segmentAsset = <AssetSegment assets={this.state.assets} />;

        if (this.state.locations.length > 0) {

            const markers = this.state.locations
                .filter(l => ((l.latitude === 0 || l.latitude) && (l.longitude === 0 || l.longitude)))
                .map(l => ({title: l.name, lat: Number(l.latitude), lng: Number(l.longitude) }));

            const mapProps = {
                zoom: 15,
                markers
            };

            displayMap = (
                <CardText>
                    <SimpleMap {...mapProps}/>
                </CardText>
            );

        }
        
        let contactList;
        if (this.state.contacts.length > 0) {
            contactList = (
                <div style={{paddingLeft: '16px'}}>
                    {this.state.contacts.map((row) => (
                        <Chip
                            label={row.name}
                            key={row.id}
                            avatar={(<ContactIcon />)}
                            url={`/dashboard/contact/${row.id}`}
                        />
                    ))}
                </div>
            );
        }

        return (
            <DetailView
                title={this.state.details.name}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <div className="cent-flex-column cent-col-8">
                        <Card className="cent-card">
                            <CardHeader
                                title={this.state.details.name}
                                subtitle={this.state.details.description}
                                avatar={(
                                    <VenueIcon
                                        style={style.icon}
                                        color={this.state.details.status === "unavailable" ? statusColours.disabled : statusColours.default}
                                    />
                                )}
                            />
                            <CardText className="cent-card-text">
                                    <div className='cent-flex-row'>
                                        <div className='cent-col-2'>
                                            <ul className="cent-list-plain">
                                                <li><em>Capacity: </em>{this.state.details.capacity}</li>
                                                <li><em>Status: </em>{this.state.details.status}</li>
                                                <li><em>Events: </em><a href={`/dashboard/venue/${this.state.details.id}/events`}>view calendar</a></li>
                                            </ul>
                                        </div>
                                        <div className='cent-col-2'>
                                            {contactList}
                                        </div>
                                    </div>
                            </CardText>
                            {displayMap}
                        </Card>
                    </div>
                    <div className="cent-flex-column cent-col-4">
                        {segmentAsset}
                        {segmentLocations}
                    </div>
                </div>
            </DetailView>
        );
    },
    
    onVenueChange: function() {
        const details = VenueStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    },
    
    onLocationsChange: function() {
        const locations = VenueLocationStore.getByVenue(this.props.id);
        if (locations !== undefined) {
            let state = assign(this.state, {locations: locations});
            this.setState(state);
        }
    },
    
    onVenueContactChange: function() {
        const contacts = VenueContactStore.getByVenue(this.props.id);
        if (contacts !== undefined) {
            let state = assign(this.state, {contacts: contacts});
            this.setState(state);
        }
    },

    onAssetChange: function () {
        const assets = VenueAssetStore.getByVenue(this.props.id);
        if (!!assets) {
            this.setState({assets: assets.filter((e) => e !== undefined && e.type !== 'e-learning')});
        }
    }

});

Venue.contextTypes = {
    auth: PropTypes.object.isRequired
};
export default withId(Venue);
